import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {
  signInPopUp,
  signOut,
  silentSignIn,
  updateUserCredentials,
  signInRedirect,
  setIsSigningIn,
  setIsSigningOut,
  setSignInChecked,
  signOutPopup,
} from './actions';
import {AuthState, NormalizedUserResultWithToken} from './types';

const initialState: AuthState = {
  accessToken: '',
  isSignedIn: false,
  isSigningIn: false,
  isSigningOut: false,
  signInChecked: false,
};

const slice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    function signInPendingReducer(state: AuthState) {
      state.isSigningIn = true;
    }

    function signInFulfilledReducer(state: AuthState, action: PayloadAction<NormalizedUserResultWithToken>) {
      state.isSigningIn = false;
      state.isSignedIn = true;

      const {accessToken} = action.payload;
      state.accessToken = accessToken;
    }

    function signInRejectedReducer(state: AuthState) {
      state.isSigningIn = false;
    }

    builder
      .addCase(signInRedirect.pending, signInPendingReducer)
      .addCase(silentSignIn.pending, signInPendingReducer)
      .addCase(signInPopUp.pending, signInPendingReducer)
      .addCase(silentSignIn.fulfilled, signInFulfilledReducer)
      .addCase(signInPopUp.fulfilled, signInFulfilledReducer)
      .addCase(silentSignIn.rejected, signInRejectedReducer)
      .addCase(signInPopUp.rejected, signInRejectedReducer)
      .addCase(signOut.fulfilled, (state) => {
        state.accessToken = initialState.accessToken;
        state.isSignedIn = initialState.isSignedIn;
        state.isSigningIn = initialState.isSigningIn;
      })
      .addCase(signOutPopup.fulfilled, (state) => {
        state.accessToken = initialState.accessToken;
        state.isSignedIn = initialState.isSignedIn;
        state.isSigningIn = initialState.isSigningIn;
        state.isSigningOut = initialState.isSigningOut;
      })
      .addCase(setIsSigningIn, (state, action) => {
        state.isSigningIn = action.payload;
      })
      .addCase(setIsSigningOut, (state, action) => {
        state.isSigningOut = action.payload;
      })
      .addCase(setSignInChecked, (state, action) => {
        state.signInChecked = action.payload;
      })
      .addCase(updateUserCredentials.pending, signInPendingReducer)
      .addCase(updateUserCredentials.fulfilled, signInFulfilledReducer)
      .addCase(updateUserCredentials.rejected, signInRejectedReducer);
  },
});

export const {reducer: authReducer} = slice;
